<template>
  <div>
    <v-card v-if="!isMinPoint" class="mx-auto px-4 py-2" :loading="loading" :disabled="loading">
      <v-card-title class="title font-weight-bold justify-space-between">
        <span class="warning--text">
          <v-icon class="mr-2" color="warning">mdi-alert-circle</v-icon>Advertencia
        </span>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-1 subtitle-1">
        Por favor complete su hoja de vida:
        <ul class="mb-4">
          <li class="mb-2" v-if="allFieldsInformacionPersonal">
            <strong>Información personal</strong>
            <div class="d-flex flex-wrap">
              <div
                v-for="(field, index) of fieldsInformacionPersonal"
                :key="index"
              >
                <v-chip
                  v-if="!curriculum.informacion_personal[field.id]"
                  small
                  class="mr-1"
                >
                  {{ field.name }}
                </v-chip>
              </div>
            </div>
          </li>
          <li v-if="allFieldsInformacionContacto">
            <strong>Información de contacto</strong>
            <div class="d-flex flex-wrap" v-if="curriculum.informacion_contacto">
              <div
                v-for="(field, index) of fieldsInformacionContacto"
                :key="index"
              >
                <v-chip
                  v-if="!curriculum.informacion_contacto[field.id]"
                  small
                  class="mr-1"
                >
                  {{ field.name }}
                </v-chip>
              </div>
            </div>
            <div class="d-flex flex-wrap" v-else>
              <div
                v-for="(field, index) of fieldsInformacionContacto"
                :key="index"
              >
                <v-chip
                  small
                  class="mr-1"
                >
                  {{ field.name }}
                </v-chip>
              </div>
            </div>
          </li>
        </ul>
         <!-- e -->
        <!-- <strong>Información de contacto</strong> -->
        <!-- y <strong>Objetivo laboral</strong> -->
        como mínimo para postular a un empleo
      </v-card-text>
    </v-card>
    <v-card
      v-else-if="requirementsItMeets"
      class="mx-auto px-4 py-2"
      :loading="loading"
      :disabled="loading"
    >
      <v-card-title class="title font-weight-bold justify-space-between">
        <span class="warning--text">
          <v-icon class="mr-2" color="warning">mdi-alert-circle</v-icon>Advertencia
        </span>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>Para postular a este empleo debe cumplir con los requisitos establecidos</v-card-subtitle>
      <v-card-text class="pt-1 subtitle-1 font-weight-bold" v-html="requirementsItMeets"></v-card-text>
    </v-card>
    <v-card v-else class="mx-auto" :loading="loading" :disabled="loading">
      <v-card-title class="title font-weight-bold justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pb-3">{{ currentSubTitle }}</v-card-subtitle>

      <div v-if="errorExists">
        <v-divider></v-divider>
        <v-alert
          v-model="errorExists"
          type="error"
          dismissible
          text
          tile
          dense
          class="px-6 mb-0"
        >{{ error }}</v-alert>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <v-window v-model="step">
          <v-window-item :value="1">
            <span
              class="grey--text text--darken-1 d-block"
            >Escribe tu sueldo bruto pretendido que serías ideal para este puesto. Es opcional, ¡pero suma mucho!</span>
            <BaseMyTextField
              type="number"
              v-model="application.salario_pretendido"
              placeholder="Ingresa tu sueldo bruto pretendido"
              prefix="$"
            ></BaseMyTextField>
          </v-window-item>

          <v-window-item :value="2">
            <span
              class="grey--text text--darken-1 d-block"
            >Escribe una carta de postulación contando por qué serías ideal para este puesto. Es opcional, ¡pero suma mucho!</span>
            <BaseMyTextArea
              v-model="application.carta_postulacion"
              no-resize
              counter="1000"
              maxlength="1000"
              placeholder="¿Qué te diferencia de los demás candidatos?"
            ></BaseMyTextArea>
          </v-window-item>

          <v-window-item v-if="application.preguntas.length" :value="3">
            <span
              class="grey--text text--darken-1 d-block mb-4"
            >La empresa requiere que conteste las siguientes preguntas para postular (Obligatorio).</span>
            <div v-for="(pregunta, index) of application.preguntas" :key="index" class="mt-6">
              <span class="font-weight-bold">{{ pregunta.pregunta }}</span>
              <BaseMyTextField
                v-if="pregunta.tipo !== 'Opción multiple'"
                class="pt-0"
                v-model="pregunta.respuesta"
                placeholder="Respuestas"
                hide-details
              ></BaseMyTextField>
              <v-radio-group v-else v-model="pregunta.respuesta" class="mt-0" hide-details>
                <v-radio
                  v-for="(option, index) of pregunta.opciones"
                  on-icon="mdi-checkbox-blank-circle"
                  :label="option"
                  :value="option"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-window-item>

          <v-window-item :value="4">
            <div class="pa-4 text-center">
              <h3 class="title font-weight-light mb-2">
                Te postulaste a
                <span class="font-weight-bold primary--text">{{ job.titulo }}</span>
                en la empresa
                <span
                  class="font-weight-bold primary--text"
                >{{ job.empresa.nombre_empresa }}</span>.
                ¡Buena suerte!
              </h3>
            </div>
          </v-window-item>
        </v-window>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4">
        <v-btn
          :disabled="step === 1"
          text
          @click="step--"
          class="font-weight-bold"
          color="grey darken-1"
        >Volver</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="step === 4 || validContinue"
          color="primary"
          text
          @click="nextStep()"
          class="font-weight-bold"
        >
          {{
          this.application.preguntas.length && this.step === 3 || !this.application.preguntas.length && this.step === 2
          ? 'Postularme'
          : 'Continuar'
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import store from "@/store";

import { mapState } from "vuex";

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false,
    step: 1,
    error: "",
    errorExists: false,
    application: {
      salario_pretendido: 0.0,
      carta_postulacion: "",
      preguntas: []
    },
    fieldsInformacionPersonal: [
      {
        id: 'profile_image',
        name: 'Imagen de perfil'
      },
      {
        id: 'nombres',
        name: 'Nombres'
      },
      {
        id: 'apellidos',
        name: 'Apellidos'
      },
      {
        id: 'fecha_nacimiento',
        name: 'Fecha de nacimiento'
      },
      {
        id: 'genero',
        name: 'Género'
      },
      {
        id: 'nacionalidad',
        name: 'Nacionalidad'
      },
      {
        id: 'estado_civil',
        name: 'Estado Civil'
      },
      {
        id: 'tipo_documento',
        name: 'Tipo de documento'
      },
      {
        id: 'numero_documento',
        name: 'Número de documento'
      },
    ],
    fieldsInformacionContacto: [
      {
        id: 'correo',
        name: 'Correo de contacto'
      },
      {
        id: 'celular',
        name: 'celular'
      },
      {
        id: 'pais',
        name: 'País'
      },
      {
        id: 'provincia',
        name: 'Provincia'
      },
      {
        id: 'ciudad',
        name: 'Ciudad'
      },
      {
        id: 'direccion',
        name: 'Dirección'
      },
    ]
  }),
  computed: {
    ...mapState("postulants/curriculum", ["curriculum"]),
    allFieldsInformacionPersonal() {
      if (!this.curriculum.informacion_personal) return true;
      const fileds = this.fieldsInformacionPersonal.filter(field => !this.curriculum.informacion_personal[field.id]);
      return !!fileds.length;
    },
    allFieldsInformacionContacto() {
      if (!this.curriculum.informacion_contacto) return true;
      const fileds = this.fieldsInformacionContacto.filter(field => !this.curriculum.informacion_contacto[field.id]);
      return !!fileds.length;
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Salario bruto pretendido";
        case 2:
          return "Carta de postulación";
        case 3:
          return "Preguntas";
        case 4:
          return "";
        default:
          return "Account created";
      }
    },
    currentSubTitle() {
      switch (this.step) {
        case 1:
          return "";
        case 2:
          return "Aumenta las posibilidades de que te elijan";
        case 3:
          return "";
        case 4:
          return "";
        default:
          return "Account created";
      }
    },
    validContinue() {
      return (
        this.step === 3 &&
        !this.application.preguntas.every(pregunta => pregunta.respuesta)
      );
    },
    isMinPoint() {
      return this.curriculum.puntaje_maximo
        && this.curriculum.puntaje
        && this.curriculum.puntaje_maximo.informacion_personal === this.curriculum.puntaje.informacion_personal
        && this.curriculum.puntaje_maximo.informacion_contacto === this.curriculum.puntaje.informacion_contacto
        // && this.curriculum.puntaje_maximo.objetivo_laborals === this.curriculum.puntaje.objetivo_laborals;
    },
    age() {
      if (!this.curriculum.informacion_personal.fecha_nacimiento) return "";
      return this.$moment().diff(
        this.curriculum.informacion_personal.fecha_nacimiento,
        "years"
      );
    },
    requirementsItMeets() {
      let message = "";
      if (!this.job.requerimientos) return "";

      let fulfillEducation;
      if (this.job.requerimientos.educacion) {
        fulfillEducation = this.curriculum.educacion.find(
          educacion =>
            educacion.tipo_estudio ===
              this.job.requerimientos.educacion.nivel_educativo &&
            educacion.estado === this.job.requerimientos.educacion.estado
        );
      }

      let fulfillWorkExperience;
      if (this.job.requerimientos.experiencia) {
        fulfillWorkExperience = this.curriculum.experiencia_laborales.find(
          work =>
            work.area_puesto === this.job.area &&
            this.$moment(work.fecha_fin || new Date()).diff(
              work.fecha_inicio,
              "years"
            ) >= this.job.requerimientos.experiencia.experiencia_minima
        );
      }

      const languageLevel = {
        Básico: 0,
        Intermedio: 1,
        Avanzado: 2,
        Nativo: 3
      };

      let fulfillLanguage;
      if (this.job.requerimientos.idiomas) {
        fulfillLanguage = this.job.requerimientos.idiomas.every(idioma => {
          const lenguage = this.curriculum.idiomas.find(
            language => language.idioma === idioma.idioma
          );
          return (
            idioma.es_excluyente &&
            lenguage &&
            (languageLevel[lenguage.nivel_escrito] >=
              languageLevel[idioma.nivel] ||
              languageLevel[lenguage.nivel_escrito] >=
                languageLevel[idioma.nivel])
          );
        });
      }

      if (
        this.job.requerimientos.edad &&
        this.job.requerimientos.edad.es_excluyente &&
        (this.age < this.job.requerimientos.edad.edad_min ||
          this.age > this.job.requerimientos.edad.edad_max)
      )
        message += "<div>No cumple con el rango de edad solicitado</div>";
      if (
        this.job.requerimientos.sexo &&
        this.job.requerimientos.sexo.es_excluyente &&
        this.curriculum.informacion_personal.genero !==
          this.job.requerimientos.sexo.sexo
      )
        message += "<div>No cumple con el género solicitado</div>";
      if (
        this.job.requerimientos.educacion &&
        this.job.requerimientos.educacion.es_excluyente &&
        !fulfillEducation
      )
        message += "<div>No cumple con el nivel educativo solicitado</div>";
      if (
        this.job.requerimientos.experiencia &&
        this.job.requerimientos.experiencia.es_excluyente &&
        !fulfillWorkExperience
      )
        message +=
          "<div>No cumple con la experiencia laboral en el área indicada</div>";
      if (
        this.job.requerimientos.idiomas &&
        this.job.requerimientos.idiomas.length &&
        !fulfillLanguage
      )
        message +=
          "<div>No cumple con el nivel de conocimientos mínimos solicitados</div>";
      return message;
    }
  },
  created() {
    this.application.preguntas = this.job.preguntas;
  },
  methods: {
    close() {
      (this.step = 1),
        (this.application = {
          salario_pretendido: 0.0,
          carta_postulacion: "",
          preguntas: this.application.preguntas.map(pregunta => ({
            ...pregunta,
            respuesta: ""
          }))
        });
      this.$emit("close", false);
    },
    nextStep() {
      if (
        this.step === 3 ||
        (!this.application.preguntas.length && this.step === 2)
      ) {
        this.loading = true;
        this.error = "";
        this.errorExists = false;
        store
          .dispatch("job/applyWork", {
            aviso: this.job._id,
            data: this.application
          })
          .then(response => {
            this.$emit("applied", true);
            this.close();
            this.$store.commit("SET_ALERT", {
              color: "green",
              text: "Postulación realizada con éxito",
              visible: true
            });
          })
          .catch(error => {
            this.$store.commit("SET_ALERT", {
              color: "red",
              text: "Error al realizar postulación",
              visible: true
            });
            this.error = error.response
              ? error.response.data.message
              : "Ocurrio un error al postular al empleo. intente nuevamente";
            this.errorExists = true;
          })
          .finally(() => {
            this.loading = false;
          });
      } else
        !this.application.preguntas.length && this.step === 2
          ? (this.step += 2)
          : (this.step += 1);
    }
  }
};
</script>